import { render, staticRenderFns } from "./studentStatisticalReport.vue?vue&type=template&id=8c19852e&"
import script from "./studentStatisticalReport.vue?vue&type=script&lang=js&"
export * from "./studentStatisticalReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports